import { render, staticRenderFns } from "./BvCloseDialog.vue?vue&type=template&id=cacb73ce&"
import script from "./BvCloseDialog.vue?vue&type=script&lang=ts&"
export * from "./BvCloseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports